var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "location_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#location_svg__a",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  id: "location_svg__a",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#location_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2.667A6.333 6.333 0 0 0 5.667 9c0 3.498 5.176 12.333 6.333 12.333S18.334 12.498 18.334 9A6.333 6.333 0 0 0 12 2.667m.001 1.33c-2.761 0-5 2.278-5 5.089 0 2.81 4.294 10.254 4.999 10.254s5.001-7.443 5.001-10.254-2.239-5.09-5-5.09"
})))));
export default SvgLocation;